import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ConsentsVehicleResponse, ICreateConsentDecisionsPayload } from './types';

export class TTDSGConsentClient {

    private readonly locale: string;
    private readonly resourceHostId: string;

    private getGdcType = (isWcar: boolean) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;

    constructor(
        private readonly authServiceWeConnect: IAuthServiceV2,
        private readonly localeService: LocaleServiceV1,
        private readonly stage: string
    ) {
        this.locale = `${this.localeService.language}-${this.localeService.countryCode}`;
        this.resourceHostId = `myvw-ttdsg-consent-${stage}`;
    }

    public async getDocumentConsentVehicle(isWcar: boolean, userId: string): Promise<ConsentsVehicleResponse> {

        const response = await this.authServiceWeConnect.get(this.resourceHostId,
            `api/v1/consents/vehicle?gdc=${this.getGdcType(isWcar)}&userId=${userId}&locale=${this.locale}`);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as ConsentsVehicleResponse;
    }

    public async createConsent(payload: ICreateConsentDecisionsPayload, isWcar: boolean, userId: string): Promise<void>
    {
        const response = await this.authServiceWeConnect.post(this.resourceHostId,
            `api/v1/consents/vehicle?gdc=${this.getGdcType(isWcar)}&userId=${userId}&locale=${this.locale}`,
            JSON.stringify(payload),
            {
                'Content-Type': 'application/json'
            }
        );

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }

}
